import styled from 'styled-components';

export const StyledSpan = styled.span`
  padding: 5px 10px;
`;
